import React from 'react';
import { ListiclePage } from './components/ListiclePage';
export function App() {
  return <ListiclePage data-id="element-0" />;
}